<div class="body-container-wrapper">
    <section class="inner-page-banner about-us-banner">
      <div class="container">
        <div class="banner-caption">
          <h1>Creating Crorepatis Since 1964</h1>
          <h6>Because when it comes to your Money, an expert advice can make all the difference.</h6>
        </div>
      </div>
      <div class="section-menu scroll_active" data-href="#section-menu" id="section-menu">
        <ul>
          <li class="scroll_active" data-href="#journey"><a href="#journey"
              >Journey</a></li>
          <li class="scroll_active" data-href="#vision"><a href="#vision"
              >Vision</a></li>
          <li class="scroll_active" data-href="#leadership"><a href="#leadership"
                >Leadership</a></li>
          <li class="scroll_active" data-href="#Philosophy"><a href="#Philosophy"
              >Philosophy</a></li>
          <li class="scroll_active" data-href="#services"><a href="#services"
              >Services</a></li>
  
        </ul>
        <div class="mobile-scroll-menu d-sm-none">
          <span>Jump to Section</span>
          <div class="custom-dropdown">
            <span class="selected-item form-control">Journey</span>
            <ul>
              <li><a href="#journey" >Journey</a></li>
              <li><a href="#vision">Vision</a></li>
              <li><a href="#leadership">Leadership</a></li>
              <li><a href="#Philosophy">Philosophy</a></li>
              <li><a href="#services">Services</a></li>
  
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="journey-carousel-section bgwhite" id="journey">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-10 col-xl-8 text-center">
            <h2>{{journey_title}}</h2>
            <p>{{journey_description}}</p>
          </div>
          <div class="col-12">
            <div class="">
              <ngx-slick-carousel class="carousel journey_slider tab-listing journey-listing" #slickModal="slick-carousel"
                [config]="slideConfig">
                <div ngxSlickItem class="tab-list" *ngFor="let jrList of journey; let i=index;">
                  <a href="#" [class.active]="i===0"
                    attr.data-target="{{jrList.journey_year}}{{jrList.journey_nid}}">{{jrList.journey_year}}</a>
                  <span class="monthwise">{{jrList.journey_month}}</span> 
                </div>
              </ngx-slick-carousel>
              <!-- <div class="tab-list  slick-slide slick-current slick-active" *ngFor="let jrList of journey; let i=index;">
                            <a href="#" [class.active]="i===0" attr.data-target="{{jrList.journey_year}}">{{jrList.journey_year}}</a>
                        </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="journey-tab-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 col-xl-10">
            <div class="tab-wrapper">
              <ng-container *ngFor="let data of journey; let x = index;">
  
                <div class="tab" id="{{data.journey_year}}{{data.journey_nid}}"
                  [ngStyle]="{'display':x === 0 ? 'block' : 'none' }">
                  <div class="row journey-container justify-content-between">
                    <div class="col-lg-6"><img src="{{data.banner_image}}" alt=""></div>
                    <div class="journey-caption col-lg-6 col-xl-5">
                      <h3>{{data.journey_title}}</h3>
                      <p>{{data.journey_description}}</p>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- </div> -->
            </div>
            <!-- <div class="col-12 text-center mt-4">
                            <a href="#" class="read-more">Track how we are doing this year <i class="fas fa-chevron-right"></i></a>
                        </div> -->
          </div>
        </div>
      </div>
    </section>

    <section class="bgwhite founder-section" id="vision">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-10 col-xl-8 text-center">
            <h2>Our Founder</h2>
            <p>Established BajajCapital about 56 years ago and has vast experience in the field of financial services.</p>
            <div class="row">
              <div class="col-md-12">
                <a href="/about-us/kkbajaj" target="_blank">
                  <div class="card red-card profile-card">
                    <div class="card-img-wrapper">
                      <img src="../../assets/images/about/kk.jpg" alt="" class="card-img-top">
                    </div>
                    <div class="card-body">
                      <h4 class="profile-name">Mr. KK Bajaj</h4>
                      <p class="designation">Founder & Emeritus Chairman</p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-6">
                <div class="card grey-card">
                  <div class="card-body">
                    <h4 class="card-title">Our Mission<span class="wow"></span></h4>
                    <p>Provide need-based solutions at the right value, gaining lifetime client relationships through a happy team & service excellence.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card grey-card">
                  <div class="card-body">
                    <h4 class="card-title">Our Vision<span class="wow"></span></h4>
                    <p>India's most admired & recommended wealth creation & protection brand. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bgwhite directors-section" id="leadership">
      <div class="container">
        <h2 class="text-center mb-4">{{leadership_title}}</h2>
        <div class="justify-content-between">
          <app-leader [leadership_title]="leadership_title" [leaders]="leaders"></app-leader>
        </div>
      </div>
    </section>
  
    <section class="advantage-section" id="Philosophy">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="card-title section-title">
              BajajCapital Core ENRICH Values <span class="wow"></span>
            </h2>
            <div class="module-icon text-center section-logo">
              <img src='./assets/images/about/enrich-logo.png' />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mb-3">
            <div class="advantage-module mt-4">
              <div class="module-icon">
                <img src="assets/images/about/ethical-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Entrepreneurial & Ethical</h6>
                <ul class="listing">
                  <li>
                    Cites and shares correct/incorrect behavior openly and
                    honestly
                  </li>
                  <li>Treat co-workers with integrity and respect</li>
                  <li>
                    Proactively seeks feedback/support when needed to improve self
                    performance
                  </li>
                  <li>Is a brand ambassador to BajajCapital</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mb-3">
            <div class="advantage-module">
              <div class="module-icon">
                <img src="assets/images/about/nuturing-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Nurturing</h6>
                <ul class="listing">
                  <li>Exhibits traits to handhold new members in the team</li>
                  <li>
                    Recognizes and appreciates team members and co workers for
                    their success stories
                  </li>
                  <li>
                    Proactively follows up with reporting manager and support team
                    for career aspirations and growth plan
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="advantage-module">
              <div class="module-icon">
                <img src="assets/images/about/responsibility-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Responsibility</h6>
                <ul class="listing">
                  <li>
                    Proactively fill up for my team members deliverables in their
                    absence
                  </li>
                  <li>
                    Take charge and follow up on my development and career path
                  </li>
                  <li>
                    Always operate out of my circle of influence and do what i do
                    best to deliver on what is expected from me
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mb-3">
            <div class="advantage-module">
              <div class="module-icon">
                <img src="assets/images/about/innovation-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Innovation</h6>
                <ul class="listing">
                  <li>
                    Always stay ahead and implement best practices and creativity
                    in all tasks done
                  </li>
                  <li>
                    Maximize the use of technology and digital media for day job &
                    communication
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mb-3">
            <div class="advantage-module">
              <div class="module-icon">
                <img src="assets/images/about/collaboration-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Collaboration</h6>
                <ul class="listing">
                  <li>
                    Communicate with each and every individual in the team and
                    maintain professionalism
                  </li>
                  <li>
                    Always coordinates with team members for timely completion of
                    tasks
                  </li>
                  <li>Have fun and celebrate success together</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mb-3">
            <div class="advantage-module">
              <div class="module-icon">
                <img src="assets/images/about/happy-client-icon.png" width="42" />
              </div>
              <div class="module-content">
                <h6>Happy Clients & Happy Teams</h6>
                <ul class="listing">
                  <li>
                    Works towards continuous improvement of client experience at
                    BajajCapital
                  </li>
                  <li>
                    Understand and listen to the customer expectations at all
                    times
                  </li>
                  <li>
                    Always capture customer feedback and internalize it when
                    required
                  </li>
                  <li>
                    Manages relationships with peers by being transparent, open
                    and upfront with colleagues, when needed
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
  
    <section class="bgwhite d-none" id="services">
      <div class="container">
      </div>
    </section>
    <section class="sub-footer" id="contactus">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-md-5">
            <h2>Let's get in touch</h2>
  
            <p>If you would like to ask us anything, we are always here to help. Just drop our customer support team a
              mail at <a href="mailto:contactus@bajajcapital.com"
                >contactus@bajajcapital.com</a> any time
              of the day, or call  <span
                > / <a 
                  > 1800-313-123123</a></span> Mon - Sat (10AM
              - 6PM).</p>
          </div>
          <div class="col-md-7 col-lg-6 col-xl-5">
            <h2>Or walk into your nearest branch...</h2>
            <p>Serving and enabling all your financial soluions.<br>Just drop in for personalized review services and
              guidance<br><a [routerLink]="['/help-centre#branch']" class="btn read-more mt-5"
                >Branch Locator <i
                  class="fas fa-chevron-right"></i></a></p>
          </div>
        </div>
      </div>
    </section>
  </div>